const frontendURL = process.env.REACT_APP_FRONTEND_URL;
const authority = process.env.REACT_APP_AUTHORITY;
const clientId = process.env.REACT_APP_CLIENT_ID;
export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: authority || "https://login.microsoftonline.com/common",
    redirectUri: frontendURL,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access", "User.Read"],
};